import { useState, useEffect } from "react";
import CampaignListView from "../../components/campaign/CampaignListView";
import CampaignCardView from "../../components/campaign/CampaignCardView";
import CampaignListCardView from "../../components/campaign/CampainListCardView";
import {
  useCampignWorkflowQuery,
  useCampainPaginationQuery,
} from "../../Services/campign/campignList";
import { useMeeQuery } from "../../Services/settingsAPIs/CommonAPI";
import { useCampaignQuery } from "../../Services/campign/campignList";
import ReactModal from "react-modal";
import CampaignLeadModel from "./CampaignLeadModel";
import { toast } from "react-toastify";
import BulkAssigneeLeadModel from "./BulkAssigneeLeadModel";
import DeleteBulkLeadModel from "./DeleteBulkLeadModel";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Checkbox,
  Tooltip,
} from "@mui/material";
import CampaignFilterModel from "./CampaignFilterModel";
import { useNavigate } from "react-router-dom";
import LoadingSpinner from "../../components/LoadingSpinner";
import BroadcastModal from "./BroadcastModal";
import { CIRCLEONE_TEAM, CIRCLEONE_USERNAME } from "../../constants";
import "../../pages/ticket/TicketList.scss";

const CampaignList = () => {
  const [selectedOptions, setSelectedOptions] = useState<string[]>([]);
  const [headerOption, setHeaderOption] = useState<any>([
    { id: "1", name: "Lead Id" },
    { id: "2", name: "Assignee" },
    { id: "3", name: "Priority" },
  ]);
  const [selectedCampaign, setSelectedCampaign] = useState<any>([]);

  const handleMultiSelectChange = (selectedIds: string[]) => {
    if (selectedIds.length > 5) {
      toast.error("You can only select up to 5 headers.");
    } else {
      const updatedOptions = headerOption.filter((option) =>
        selectedIds.includes(option.id),
      );
      setSelectedOptions(updatedOptions);
    }
  };

  const handleSelectAll = () => {
    if (selectedOptions.length > 0) {
      setSelectedOptions([]);
    } else {
      setSelectedOptions(headerOption.slice(0, 5));
    }
  };

  const userRole = localStorage.getItem("user_role");

  const taskRes = [
    {
      taskname: "folow up on payment",
      duedate: "12/1/23",
      frequency: "monthly",
      owner: "Archana",
      status: "pending",
    },
    {
      taskname: "folow up on payment",
      duedate: "12/1/23",
      frequency: "monthly",
      owner: "Archana",
      status: "pending",
    },
    {
      taskname: "folow up on payment",
      duedate: "12/1/23",
      frequency: "monthly",
      owner: "Archana",
      status: "pending",
    },
    {
      taskname: "folow up on payment",
      duedate: "12/1/23",
      frequency: "monthly",
      owner: "Archana",
      status: "pending",
    },
  ];

  const listOfLeads = [
    {
      isSelected: false,
      leadId: "00227",
      fname: "Prajakta",
      lname: "joshi",
      company: "Bluewhirl",
      mailid: "prajakta@bluewhirl.io",
      mobileno: "8953519254",
      status: "All",
    },
    {
      isSelected: false,
      leadId: "00228",
      fname: "Archana",
      lname: "Jagtap",
      company: "Bluewhirl",
      mailid: "archana@bluewhirl.io",
      mobileno: "6897519254",
      status: "Open",
    },
    {
      isSelected: false,
      leadId: "00229",
      fname: "Abhinev",
      lname: "Qasba",
      company: "Botgo",
      mailid: "abhinev@botgo.io",
      mobileno: "9990966200",
      status: "WIP",
    },
    {
      isSelected: false,
      leadId: "00230",
      fname: "Kiran",
      lname: "Singh",
      company: "Botgo",
      mailid: "kiran@botgo.io",
      mobileno: "9990099638",
      status: "Ready",
    },
    {
      isSelected: false,
      leadId: "00231",
      fname: "Shivam",
      lname: "Shakya",
      company: "Botgo",
      mailid: "shivam@botgo.io",
      mobileno: "8888262122",
      status: "Closed",
    },
  ];

  // ── Modal style objects ───────────────────────────────────────────────────
  const customModalStyles1 = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "100%",
      maxHeight: "80%",
      maxWidth: "850px",
      margin: "auto",
      Overflow: "hidden",
      OverflowY: "auto",
    },
  };
  const customEditModalStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "28%",
      maxWidth: "1150px",
      margin: "auto",
      Overflow: "hidden",
      OverflowY: "auto",
    },
  };
  const customResetPassModalStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "450px",
      maxWidth: "850px",
      margin: "auto",
      Overflow: "hidden",
      OverflowY: "auto",
    },
  };
  const customFilterModalStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "100%",
      maxWidth: "50px",
      margin: "auto",
      Overflow: "hidden",
      OverflowY: "auto",
    },
  };
  const customModalStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "100%",
      maxWidth: "850px",
      height: "50%",
      margin: "auto",
      Overflow: "hidden",
      OverflowY: "auto",
    },
  };

  // ── State ─────────────────────────────────────────────────────────────────
  const storedOption =
    sessionStorage.getItem("selectedOptionCampign") || "campaignListCardView";
    const [outwardLeadButton, setOutwardLeadButton] = useState<boolean>(() => {
      const stored = sessionStorage.getItem("outwardLeadButton");
      return stored !== null ? stored === "true" : true;
    });
  const [selectedOption, setSelectedOption] = useState(storedOption);

  const [campaignListViewPage, setCampaignListViewPage] = useState<number>(() =>
    Number(sessionStorage.getItem("campaignListViewPage") || 1),
  );
  const [campaignListCardViewPage, setCampaignListCardViewPage] =
    useState<number>(() =>
      Number(sessionStorage.getItem("campaignListCardViewPage") || 1),
    );
  const [campaignCardViewPage, setCampaignCardViewPage] = useState<number>(() =>
    Number(sessionStorage.getItem("campaignCardViewPage") || 1),
  );

  const [campaignListViewPageSize, setCampaignListViewPageSize] =
    useState<number>(() =>
      Number(sessionStorage.getItem("campaignListViewPageSize") || 5),
    );
  const [campaignListCardViewPageSize, setCampaignListCardViewPageSize] =
    useState<number>(() =>
      Number(sessionStorage.getItem("campaignListCardViewPageSize") || 5),
    );
  const [campaignCardViewPageSize, setCampaignCardViewPageSize] =
    useState<number>(() =>
      Number(sessionStorage.getItem("campaignCardViewPageSize") || 5),
    );

  const [selectedTickets, setSelectedTickets] = useState<string[]>([]);
  const [liftingKey, setLiftingKey] = useState([]);
  const [isFilterModalOpen, setFilterIsModalOpen] = useState(false);
  const { data: useData } = useMeeQuery({});
  const [liftUiData, setLiftUiData] = useState(0);
  const [value, setValue] = useState(liftUiData ? "active" : "All");
  const [storeKey, setStoreKey] = useState(liftUiData ? "active" : "All");
  const navigate = useNavigate();

  const getCurrentPage = () => {
    switch (selectedOption) {
      case "campaignListView":
        return campaignListViewPage;
      case "campaignListCardView":
        return campaignListCardViewPage;
      case "campaignCardView":
        return campaignCardViewPage;
      default:
        return 1;
    }
  };

  const getCurrentPageSize = () => {
    switch (selectedOption) {
      case "campaignListView":
        return campaignListViewPageSize;
      case "campaignListCardView":
        return campaignListCardViewPageSize;
      case "campaignCardView":
        return campaignCardViewPageSize;
      default:
        return 5;
    }
  };

  const setCurrentPage = (page: number) => {
    switch (selectedOption) {
      case "campaignListView":
        setCampaignListViewPage(page);
        sessionStorage.setItem("campaignListViewPage", page.toString());
        break;
      case "campaignListCardView":
        setCampaignListCardViewPage(page);
        sessionStorage.setItem("campaignListCardViewPage", page.toString());
        break;
      case "campaignCardView":
        setCampaignCardViewPage(page);
        sessionStorage.setItem("campaignCardViewPage", page.toString());
        break;
    }
  };

  const handleDropdownChange = (event) => {
    const selected = event.target.value;
    setSelectedOption(selected);
    sessionStorage.setItem("selectedOptionCampign", selected);
    setSelectedTickets([]);
    setCurrentPage(1);
  };

  const [isLoadingPageChange, setIsLoadingPageChange] =
    useState<boolean>(false);
  const [data, setData] = useState<any>();
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);

  const teamIdFromLocalStorage = localStorage.getItem("teamId");
  const { data: camapignData, refetch: refetchCampaigns } = useCampaignQuery({
    teamId: teamIdFromLocalStorage,
    campaignType: outwardLeadButton,
  });

  const [selectedTeamId, setSelectedTeamId] = useState(() => {
    const fromSession = sessionStorage.getItem("selectedTeamId");
    const role = localStorage.getItem("user_role");
    const userId = localStorage.getItem("User_Id");
    if (fromSession) return fromSession;
    if (role === "admin") return "My Team";
    if (role === "agent" || role === "manager") return userId;
    return null;
  });

  const [selectedCampain, setSelectedCampain] = useState<number>();
  const [theCampaign, setTheCampaign] = useState([]);
  const [campaignId, setCampaignId] = useState<number>();
  const [workflowName, setWorkflowName] = useState<string>("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isBulk, setIsBulk] = useState(false);
  const [isBulkAssigneeModalOpen, setIsBulkAssigneeModalOpen] = useState(false);
  const [isBulkBrodardcastModalOpen, setIsBulkBroardcastModalOpen] =
    useState(false);
  const [isBulkDeleteModalOpen, setIsBulkDeleteModalOpen] = useState(false);

  const checkTeam = localStorage.getItem(CIRCLEONE_TEAM);
  const checkUsername = localStorage.getItem(CIRCLEONE_USERNAME);

  const [selectedCampaignFilterAndValue, setSelectedFilterAndValue] =
    useState<any>({
      email__icontains: "",
      assignee__username__icontains: "",
      account_name__icontains: "",
      created: "",
      first_name__icontains: "",
      last_name__icontains: "",
      phone_number__icontains: "",
    });

  const [selectedFilterAndValue1, setSelectedFilterAndValue1] = useState<any>(
    () => {
      const sessionData = sessionStorage.getItem(
        "selectedCampaignFilterAndValue",
      );
      return sessionData
        ? JSON.parse(sessionData)
        : {
            email__icontains: "",
            assignee__username__icontains: "",
            account_name__icontains: "",
            created: "",
            first_name__icontains: "",
            last_name__icontains: "",
            phone_number__icontains: "",
          };
    },
  );

  useEffect(() => {
    sessionStorage.setItem(
      "selectedCampaignFilterAndValue",
      JSON.stringify(selectedFilterAndValue1),
    );
  }, [selectedFilterAndValue1]);

  const { data: CampaignWorkflow, refetch: refetchWorkflow } =
    useCampignWorkflowQuery(
      {
        selectedWorkFlow: workflowName,
        selectCampaign: campaignId,
        selectedFilterAndValue1,
        selectedTeamId,
      },
      { skip: !campaignId || !workflowName },
    );

  const { data: fetchedData, refetch } = useCampainPaginationQuery(
    {
      currentPage: getCurrentPage(),
      selectCampaign: campaignId,
      value,
      liftingKey,
      storeKey,
      selectedFilterAndValue1,
      selectedTeamId,
      pageSize: getCurrentPageSize(),
    },
    { skip: !campaignId },
  );

  useEffect(() => {
    setIsLoadingPageChange(true);
    if (fetchedData?.results) setData(fetchedData?.results);
    setIsLoadingPageChange(false);
  }, [fetchedData, getCurrentPage()]);

  useEffect(() => {
    if (fetchedData) setData(fetchedData);
  }, [fetchedData]);

  useEffect(() => {
    if (camapignData && teamIdFromLocalStorage) {
      const filteredCampaigns =
        camapignData.results?.filter(
          (campaign) => campaign?.team?.id === Number(teamIdFromLocalStorage),
        ) || [];
      setTheCampaign(filteredCampaigns);
      if (filteredCampaigns.length > 0) {
        const sessionCampaignId = sessionStorage.getItem("selectedCampaignId");
        let defaultCampaign = filteredCampaigns[0];
        if (sessionCampaignId) {
          const stored = filteredCampaigns.find(
            (c) => c.id === Number(sessionCampaignId),
          );
          if (stored) defaultCampaign = stored;
        }
        setSelectedCampaign(defaultCampaign);
        setSelectedCampain(defaultCampaign.id);
        setCampaignId(defaultCampaign.id);
        setWorkflowName(defaultCampaign.campaign_name);
        setIsButtonDisabled(!defaultCampaign.campaign_name);
        sessionStorage.setItem(
          "selectedCampaignId",
          defaultCampaign.id.toString(),
        );
      } else {
        toast.warning("No campaigns assigned.");
      }
    }
  }, [camapignData, teamIdFromLocalStorage]);

  useEffect(() => {
    if (campaignId && workflowName) refetchWorkflow();
  }, [campaignId, workflowName, refetchWorkflow]);

  useEffect(() => {
    if (
      data &&
      Array.isArray(data.results) &&
      data.results.length > 0 &&
      data.results[0]?.dynamic_fields
    ) {
      const dynamicKeys = Object.keys(data.results[0]?.dynamic_fields);
      const dynamicOptions = dynamicKeys.map((key, index) => ({
        id: `${headerOption.length + index + 1}`,
        name: key,
      }));
      setHeaderOption((prev) => [...prev, ...dynamicOptions]);
    }
  }, [data]);

  const handleSelectCampainChange = async (event: any) => {
    setCampaignListViewPage(1);
    setCampaignListCardViewPage(1);
    setCampaignCardViewPage(1);
    sessionStorage.setItem("campaignListViewPage", "1");
    sessionStorage.setItem("campaignListCardViewPage", "1");
    sessionStorage.setItem("campaignCardViewPage", "1");
    sessionStorage.setItem("campaignCurrentPage", "1");
    const id = Number(event.target.value);
    setSelectedCampain(id);
    setCampaignId(id);
    sessionStorage.setItem("selectedCampaignId", id.toString());
    const found = theCampaign.find((c: any) => c.id === id);
    if ((found as any)?.campaign_name) {
      setWorkflowName((found as any).campaign_name);
      setIsButtonDisabled(false);
    } else {
      toast.error("Workflow not mapped to this campaign.");
      setIsButtonDisabled(true);
    }
  };

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  const openBulkModal = () => {
    if (!selectedTickets.length) return toast.error("Please select Lead.");
    setIsBulkAssigneeModalOpen(true);
  };
  const closeBulkModal = () => {
    setSelectedTickets([]);
    setIsBulkAssigneeModalOpen(false);
  };
  const openBulkBroadcastModal = () => setIsBulkBroardcastModalOpen(true);
  const closeBulkBroadcastModal = () => {
    setSelectedTickets([]);
    setIsBulkBroardcastModalOpen(false);
  };
  const openBulkDeleteModal = () => {
    if (!selectedTickets.length) return toast.error("Please select Lead.");
    setIsBulkDeleteModalOpen(true);
  };
  const closeBulkDelateModal = () => {
    setSelectedTickets([]);
    setIsBulkDeleteModalOpen(false);
  };
  const openFilterModal = () => setFilterIsModalOpen(true);
  const closeFilterModal = () => setFilterIsModalOpen(false);

  const handleSubmit = (filterValues) => {
    setIsLoadingPageChange(true);
    setCurrentPage(1);
    setSelectedFilterAndValue1(filterValues);
    setIsLoadingPageChange(false);
  };

  const ITEM_HEIGHT = 60;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: { maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP, width: 100 },
    },
  };
  const truncateDescription = (description, maxLength) =>
    description?.length > maxLength
      ? description.slice(0, maxLength) + "..."
      : description;

  const handleBackButtonClick = () => navigate(-1);
  const handleTeamChange = (e) => {
    const id = e.target.value;
    setSelectedTeamId(id);
    setCurrentPage(1);
    sessionStorage.setItem("selectedTeamId", id);
    setIsLoadingPageChange(true);
  };

  useEffect(() => {
    const storedTeamId = localStorage.getItem("selectedTeamId");
    if (storedTeamId) setSelectedTeamId(storedTeamId);
  }, []);

  const checkTenant = localStorage.getItem("circleone-user");
  localStorage.setItem("workflowName", workflowName);
  if (campaignId !== undefined)
    localStorage.setItem("campaignId", String(campaignId));

  const handleSwitchToggle = () => {
    const newValue = !outwardLeadButton;
    setOutwardLeadButton(newValue);
    sessionStorage.setItem("outwardLeadButton", newValue.toString());
  };
  const navigateHandler = () => {
    navigate("/dashboard/lead-dashboard");
  }; 
   const tabTitles = ["Outbound lead", "Inbound lead"];
  const restrictedUser =
    checkTeam === "Botgo" && checkUsername === "vivek@gtbotgo.io";

  // Per-view page/size handlers
  const handleCampaignListViewPageChange = (page: number) => {
    setCampaignListViewPage(page);
    sessionStorage.setItem("campaignListViewPage", page.toString());
    sessionStorage.setItem("campaignCurrentPage", page.toString());
  };
  const handleCampaignListViewPageSizeChange = (size: number) => {
    setCampaignListViewPageSize(size);
    sessionStorage.setItem("campaignListViewPageSize", size.toString());
    setCampaignListViewPage(1);
    sessionStorage.setItem("campaignListViewPage", "1");
  };
  const handleCampaignListCardViewPageChange = (page: number) => {
    setCampaignListCardViewPage(page);
    sessionStorage.setItem("campaignListCardViewPage", page.toString());
    sessionStorage.setItem("campaignCurrentPage", page.toString());
  };
  const handleCampaignListCardViewPageSizeChange = (size: number) => {
    setCampaignListCardViewPageSize(size);
    sessionStorage.setItem("campaignListCardViewPageSize", size.toString());
    setCampaignListCardViewPage(1);
    sessionStorage.setItem("campaignListCardViewPage", "1");
  };
  const handleCampaignCardViewPageChange = (page: number) => {
    setCampaignCardViewPage(page);
    sessionStorage.setItem("campaignCardViewPage", page.toString());
    sessionStorage.setItem("campaignCurrentPage", page.toString());
  };
  const handleCampaignCardViewPageSizeChange = (size: number) => {
    setCampaignCardViewPageSize(size);
    sessionStorage.setItem("campaignCardViewPageSize", size.toString());
    setCampaignCardViewPage(1);
    sessionStorage.setItem("campaignCardViewPage", "1");
  };

  return (
    // ── Root classnames identical to TicketList ──
    <div className="ticket-list-info-container">
      <div className="ticket-info-wrapper">
        {/* ── Page Title Section ── */}
        <div className="page-title-section">
          <button
            className="back-button"
            onClick={handleBackButtonClick}
            aria-label="Go back"
          >
            <i className="bi bi-arrow-left"></i>
          </button>

         
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "16px",
                flex: 1,
              }}
            >
              <ul
                className="nav nav-stretch nav-line-tabs border-transparent flex-nowrap mb-0"
                style={{ display: "flex", gap: "10px" }}
              >
                {tabTitles.map((title) => (
                  <li className="nav-item" key={title}>
                    <span
                      className={`nav-link cursor-pointer ${
                        outwardLeadButton === (title === "Outbound lead")
                          ? "active fw-bolder"
                          : ""
                      }`}
                      onClick={handleSwitchToggle}
                      role="tab"
                      style={{ whiteSpace: "nowrap" }}
                    >
                      {title}
                    </span>
                  </li>
                ))}
              </ul>
              <div
                className="cursor-pointer"
                onClick={navigateHandler}
                title={`Navigate to ${
                  outwardLeadButton ? "outbound" : "inbound"
                } lead dashboard`}
              >
                <i
                  className="bi bi-graph-up-arrow"
                  style={{ fontSize: "20px", color: "#495057" }}
                />
              </div>
            </div>
          
        </div>

        {/* ── Filter Bar ── */}
        <div className="filter-bar">
          <div className="filter-left">
            {/* Select Headers – Standard view only */}
            {!restrictedUser && selectedOption === "campaignListView" && (
              <FormControl className="filter-select">
                <InputLabel id="multi-select-label">Select headers</InputLabel>
                <Select
                  labelId="multi-select-label"
                  multiple
                  value={selectedOptions.map((opt: any) => opt.id)}
                  onChange={(event) => {
                    const { value }: any = event.target;
                    if (value.includes("all")) handleSelectAll();
                    else handleMultiSelectChange(value);
                  }}
                  renderValue={(selected) =>
                    (selected as string[]).length === headerOption.length
                      ? "All"
                      : (selected as string[])
                          .map(
                            (id) => headerOption.find((o) => o.id === id)?.name,
                          )
                          .join(", ")
                  }
                  MenuProps={MenuProps}
                  label="Select headers"
                >
                  <MenuItem
                    value="all"
                    onClick={handleSelectAll}
                    style={{ fontWeight: "bold" }}
                  >
                    <Checkbox
                      checked={selectedOptions.length === headerOption.length}
                      indeterminate={
                        selectedOptions.length > 0 &&
                        selectedOptions.length < headerOption.length
                      }
                    />
                    Select all
                  </MenuItem>
                  {headerOption.map((option) => (
                    <MenuItem key={option.id} value={option.id}>
                      <Checkbox
                        checked={selectedOptions.some(
                          (opt: any) => opt.id === option.id,
                        )}
                      />
                      <Tooltip title={option.name} arrow>
                        <span>{truncateDescription(option.name, 11)}</span>
                      </Tooltip>
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}

            {/* Select Assignee */}
            {!restrictedUser && (
              <FormControl className="filter-select">
                <InputLabel id="assignee-select-label">
                  Select assignee
                </InputLabel>
                <Select
                  labelId="assignee-select-label"
                  value={selectedTeamId}
                  onChange={handleTeamChange}
                  label="Select assignee"
                >
                  {localStorage.getItem("user_role") !== "agent" && (
                    <MenuItem value="My Team">My Team</MenuItem>
                  )}
                  <MenuItem value={localStorage.getItem("User_Id")}>
                    Self
                  </MenuItem>
                </Select>
              </FormControl>
            )}

            {/* Select Campaign */}
            <FormControl className="filter-select">
              <InputLabel id="campaign-select-label">
                Select campaign
              </InputLabel>
              <Select
                labelId="campaign-select-label"
                onChange={handleSelectCampainChange}
                value={selectedCampain || 0}
                label="Select campaign"
              >
                {theCampaign?.map((el: any) => (
                  <MenuItem value={el?.id} key={el?.id}>
                    {el?.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            {/* View */}
            {!restrictedUser && (
              <FormControl className="filter-select">
                <InputLabel id="view-select-label">View</InputLabel>
                <Select
                  labelId="view-select-label"
                  value={selectedOption}
                  onChange={handleDropdownChange}
                  label="View"
                >
                  <MenuItem value="campaignListCardView">List view</MenuItem>
                  <MenuItem value="campaignListView">Standard view</MenuItem>
                  <MenuItem value="campaignCardView">Card view</MenuItem>
                </Select>
              </FormControl>
            )}

            {/* Search Filter */}
            {!restrictedUser && (
              <Button
                variant="outlined"
                className="filter-button"
                onClick={openFilterModal}
              >
                <i className="bi bi-filter" />
                <span>Search filter</span>
              </Button>
            )}
          </div>

          <div className="filter-right">
            {/* Assignee icon */}
            {!restrictedUser && (
              <div
                className="icon-button"
                onClick={openBulkModal}
                title="Assignee"
              >
                <i className="bi bi-person-fill" />
              </div>
            )}

            {/* Delete (admin/manager only) */}
            {userRole !== "agent" && (
              <Button
                variant="outlined"
                className="action-button"
                onClick={openBulkDeleteModal}
              >
                <i className="bi bi-trash" />
                <span>Delete</span>
              </Button>
            )}

            {/* Broadcast */}
            <Button
              variant="outlined"
              className="action-button"
              onClick={openBulkBroadcastModal}
            >
              <i className="bi bi-broadcast" />
              <span>Broadcast</span>
            </Button>

            {/* Tasks */}
            {!restrictedUser && (
              <Button
                variant="outlined"
                className="action-button"
                onClick={() => navigate("/campaign/eventlist")}
              >
                <i className="bi bi-list-task" />
                <span>Tasks</span>
              </Button>
            )}

            {/* Create Lead */}
            <Button
              variant="contained"
              className="primary-button"
              onClick={openModal}
              disabled={isButtonDisabled}
            >
              <i className="bi bi-plus-lg text-white" />
              <span>Lead</span>
            </Button>
          </div>
        </div>

        {/* ── Card Body ── */}
        <div className="card-body-ticket-list">
          {isLoadingPageChange ? (
            <div className="d-flex justify-content-center align-items-center">
              <LoadingSpinner />
            </div>
          ) : (
            <>
              {selectedOption === "campaignListCardView" && (
                <CampaignListCardView
                  listOfLeads={listOfLeads}
                  taskRes={taskRes}
                  CampaignWorkflow={CampaignWorkflow}
                  value={value}
                  setValue={setValue}
                  setStoreKey={setStoreKey}
                  currentPage={campaignListCardViewPage}
                  setCurrentPage={handleCampaignListCardViewPageChange}
                  useData={useData}
                  campign={data}
                  setSelectedTickets={setSelectedTickets}
                  selectedTickets={selectedTickets}
                  setLiftUiData={setLiftUiData}
                  refetch={refetch}
                  selectedWorkFlow={workflowName}
                  selectCampaign={campaignId}
                  selectedOptions={selectedOptions}
                  checkTenant={checkTenant}
                  pageSize={campaignListCardViewPageSize}
                  setPageSize={handleCampaignListCardViewPageSizeChange}
                />
              )}
              {selectedOption === "campaignListView" && (
                <CampaignListView
                  listOfLeads={listOfLeads}
                  taskRes={taskRes}
                  CampaignWorkflow={CampaignWorkflow}
                  value={value}
                  setValue={setValue}
                  setStoreKey={setStoreKey}
                  currentPage={campaignListViewPage}
                  setCurrentPage={handleCampaignListViewPageChange}
                  useData={useData}
                  campign={data}
                  setSelectedTickets={setSelectedTickets}
                  selectedTickets={selectedTickets}
                  selectedOptions={selectedOptions}
                  checkTenant={checkTenant}
                  pageSize={campaignListViewPageSize}
                  setPageSize={handleCampaignListViewPageSizeChange}
                  refetch={refetch}
                />
              )}
              {selectedOption === "campaignCardView" && (
                <CampaignCardView
                  listOfLeads={listOfLeads}
                  taskRes={taskRes}
                  CampaignWorkflow={CampaignWorkflow}
                  value={value}
                  setValue={setValue}
                  setStoreKey={setStoreKey}
                  currentPage={campaignCardViewPage}
                  setCurrentPage={handleCampaignCardViewPageChange}
                  useData={useData}
                  campign={data}
                  setSelectedTickets={setSelectedTickets}
                  selectedTickets={selectedTickets}
                  selectedOptions={selectedOptions}
                  checkTenant={checkTenant}
                  pageSize={campaignCardViewPageSize}
                  setPageSize={handleCampaignCardViewPageSizeChange}
                />
              )}
            </>
          )}
        </div>

        {/* ── Modals ── */}
        <ReactModal
          isOpen={isFilterModalOpen}
          onRequestClose={closeFilterModal}
          style={customFilterModalStyles}
          contentLabel="Campaign Filter Modal"
          shouldCloseOnOverlayClick={false}
        >
          <CampaignFilterModel
            closeFilterModal={closeFilterModal}
            selectedFilterAndValue={selectedCampaignFilterAndValue}
            setSelectedFilterAndValue={setSelectedFilterAndValue}
            handleSubmit={handleSubmit}
            setIsLoadingPageChange={setIsLoadingPageChange}
          />
        </ReactModal>

        <ReactModal
          isOpen={isModalOpen}
          onRequestClose={closeModal}
          style={!isBulk ? customModalStyles : customEditModalStyles}
          contentLabel="Lead"
          shouldCloseOnOverlayClick={false}
        >
          <CampaignLeadModel
            closeModal={closeModal}
            isBulk={isBulk}
            setIsBulk={setIsBulk}
            refetchWorkflow={refetchWorkflow}
            refetch={refetch}
            campaignId={campaignId}
            value={value}
            setValue={setValue}
            setStoreKey={setStoreKey}
            selectedCampaign={selectedCampaign}
          />
        </ReactModal>

        <ReactModal
          isOpen={isBulkAssigneeModalOpen}
          onRequestClose={closeBulkModal}
          style={customModalStyles1}
          contentLabel="Bulk Assignee"
          shouldCloseOnOverlayClick={false}
        >
          <BulkAssigneeLeadModel
            closeBulkModal={closeBulkModal}
            selectedCampaign={selectedTickets}
            refetch={refetch}
          />
        </ReactModal>

        <ReactModal
          isOpen={isBulkDeleteModalOpen}
          onRequestClose={closeBulkDelateModal}
          style={customResetPassModalStyles}
          contentLabel="Delete Campaign"
          shouldCloseOnOverlayClick={false}
        >
          <DeleteBulkLeadModel
            selectedCampaign={selectedTickets}
            closeDeleteCampaignModal={closeBulkDelateModal}
            refetch={refetch}
          />
        </ReactModal>

        <ReactModal
          isOpen={isBulkBrodardcastModalOpen}
          onRequestClose={closeBulkBroadcastModal}
          style={customModalStyles1}
          contentLabel="Bulk Broadcast"
          shouldCloseOnOverlayClick={false}
        >
          <BroadcastModal
            closeBulkModal={closeBulkBroadcastModal}
            selectedCampaign={selectedTickets}
            refetch={refetch}
            campaignSelected={selectedCampain}
          />
        </ReactModal>
      </div>
    </div>
  );
};

export default CampaignList;